import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGetRoleManagementRoles } from '../../../api/role-management-api/role-management-api';

interface RolePickerProps {
  // stores the matrix role key
  value?: string;
  onChange: (roleKey: string | undefined) => void;
  className?: string;
  disabled?: boolean;
  placeholder?: string;
  id?: string;
  ariaLabel?: string;
}

// Native select over the tenant matrix roles
const RolePicker: React.FC<RolePickerProps> = ({
  value,
  onChange,
  className,
  disabled,
  placeholder,
  id,
  ariaLabel,
}) => {
  const { t } = useTranslation('settings');
  const { data: roles, isLoading } = useGetRoleManagementRoles({
    query: { staleTime: 5 * 60 * 1000, retry: false },
  });

  return (
    <select
      id={id}
      aria-label={ariaLabel}
      className={className}
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value || undefined)}
      disabled={disabled || isLoading}
    >
      <option value="">
        {isLoading
          ? t('user.picker.loadingRoles', 'Loading roles…')
          : placeholder ?? t('user.picker.selectRole', 'Select a role…')}
      </option>
      {(roles ?? []).map(role => (
        <option key={role.id} value={role.roleKey}>
          {role.displayName}
        </option>
      ))}
    </select>
  );
};

export default RolePicker;
